module.exports = __webpack_public_path__ + "static/media/1.4cc797a4.png";